/**
 * ============================================================================
 * rpn.ts — single-sourced RPN math for the RiskRegister UI.
 * Owner: Phase 7 — risk-svc.
 * Purpose: pure functions that mirror the Java RpnCalculator. The UI uses
 *  these for the FMEA sliders (live RPN preview) and the level chip colour.
 *
 *  Thresholds MUST match Java/com.edms.risk.domain.RiskLevel#fromRpn.
 *
 * URS rows: RSK-004 (RPN bands).
 * ============================================================================
 */

import type { RiskLevel } from './useRisksQuery';

export const FMEA_MIN = 1;
export const FMEA_MAX = 5;

export function computeRpn(severity: number, occurrence: number, detectability: number): number {
  return severity * occurrence * detectability;
}

export function levelFromRpn(rpn: number): RiskLevel {
  if (rpn >= 64) return 'CRITICAL';
  if (rpn >= 30) return 'HIGH';
  if (rpn >= 10) return 'MEDIUM';
  return 'LOW';
}

export function levelDescription(level: RiskLevel): string {
  switch (level) {
    case 'CRITICAL':
      return 'CRITICAL — immediate mitigation required; CAPA auto-opens (CAPA-017).';
    case 'HIGH':
      return 'HIGH — mitigation required; reviewed at 6 and 12 months.';
    case 'MEDIUM':
      return 'MEDIUM — treat with controls; annual review.';
    case 'LOW':
      return 'LOW — accept and monitor; no scheduled cadence.';
  }
}
